import axios from "axios";

const setToken = (token) => {
  localStorage.setItem("authToken", token);
  if (token !== "") {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
};

export default setToken;
